import React, { useRef, useEffect, useState } from "react";
import ProductCard from "../components/ProductCard";
import LoadingSpinner from "../components/LoadingSpinner";
import SkeletonWrapper from "../components/SkeletonWrapper";
import SearchInput from "../components/SearchInput";
import SearchableDropdown from "../components/SearchableDropdown";
import Tabs from "../components/Tabs";
import ProductPopup from "../components/ProductPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import Constants from "../constants";
import { useTranslation } from "react-i18next";


const CatalogLayout = ({
    user,
    isMobile,
    showHeader,
    selectedLocation,
    handleBranchSelect,
    branches,
    isBranchesLoading,
    catalogId,
    isV,
    handleGoToCart,
    t,
    filteredCategoryTabs,
    activeCategory,
    handleTabChange,
    categoryFilter,
    handleCategoryFilterChange,
    categoryEnOptions,
    categoryArOptions,
    subCategoryFilter,
    handleSubCategoryFilterChange,
    subCategoryEnOptions,
    subCategoryArOptions,
    displayedProducts,
    mapProductToCardProps,
    quantities,
    setQuantities,
    handleQuantityChange,
    handleAddToCart,
    handleProductClick,
    onToggleFavorite,
    isLoading,
    isLoadingMore,
    hasMore,
    searchQuery,
    isAdding,
    selectedProduct,
    handleClosePopup,
    isRTL,
    dir,
    setSearchQuery,
    coolingPeriodData,
    disabledEntities,
    categoriesTabImages,
    handleShc,
    isFresh
}) => {
    const { i18n } = useTranslation();
    const headerRef = useRef(null);
    const [headerHeight, setHeaderHeight] = useState(0);
    const [showSearch, setShowSearch] = useState(false);
    const dragStartY = useRef(0);
    const scrollableContentRef = useRef(null);
    const [isContentScrolled, setIsContentScrolled] = useState(false);
    const [initialLoadComplete, setInitialLoadComplete] = useState(false);

     const [active, setActive] = useState(isFresh || "");

const items = [
  { key: "fresh",  label: t("Fresh") },
  { key: "frozen", label: t("Frozen") },
  { key: "school", label: t("School Products"), hidden: !user?.isShcSchool },
].filter((item) => !item.hidden);
  const handleClick = (key) => {
    setActive(key);
    handleShc(key);
  };


    const normalizedDisabledEntities = (disabledEntities || []).map(
        (entity) => (entity || "").toLowerCase()
    );
    const isSHCCoolingPeriod = (disabledEntities || [])?.some(
        (entity) => (entity || "")?.toLowerCase() === "shc"
    );
    const getIsAddToCartDisabled = (product) =>
        normalizedDisabledEntities.includes((product?.entity || "").toLowerCase());

    useEffect(() => {
        if (!initialLoadComplete && !isLoading && filteredCategoryTabs.length > 0) {
            setInitialLoadComplete(true);
        }
    }, [isLoading, initialLoadComplete, filteredCategoryTabs.length]);
console.log("normalizedDisabledEntities:", normalizedDisabledEntities);
    useEffect(() => {
        if (!isMobile) return;

        const updateHeight = () => {
            if (headerRef.current) {
                const height = headerRef.current.offsetHeight;
                setHeaderHeight(height);
            }
        };

        const timeoutId = setTimeout(updateHeight, 0);

        let resizeObserver;
        if (headerRef.current) {
            resizeObserver = new ResizeObserver(() => {
                if (headerRef.current) {
                    const height = headerRef.current.offsetHeight;
                    setHeaderHeight(height);
                }
            });
            resizeObserver.observe(headerRef.current);
        }

        window.addEventListener("resize", updateHeight);

        return () => {
            clearTimeout(timeoutId);
            if (resizeObserver) {
                resizeObserver.disconnect();
            }
            window.removeEventListener("resize", updateHeight);
        };
    }, [isMobile, activeCategory, categoryFilter, subCategoryFilter]);

    useEffect(() => {
        if (!isMobile) return;

        const scrollElement = scrollableContentRef.current;
        if (!scrollElement) return;

        const handleScroll = () => {
            const currentScrollY = scrollElement.scrollTop;
            const isScrolledDown = currentScrollY > 50;
            setIsContentScrolled(isScrolledDown);
        };

        scrollElement.addEventListener("scroll", handleScroll);
        return () => {
            scrollElement.removeEventListener("scroll", handleScroll);
        };
    }, [isMobile]);

    const renderWebLayout = () => (
        <div className="content" style={{ padding: "0px !important" }}>
            <div
                className={`catalog-wrapper${isRTL ? " rtl" : ""}`}
                style={{ direction: dir, textAlign: isRTL ? "right" : "left" }}
                dir={dir}
            >
                {activeCategory && (
                    <div className="catalog-fixed-header">
                        {isV("selectBranch") && isMobile && (
                            <div className="catalog-header">
                                <div className="location-selector">
                                    <SearchableDropdown
                                        id={`location-select-${catalogId}`}
                                        name="locationSelect"
                                        value={selectedLocation}
                                        onChange={handleBranchSelect}
                                        options={branches.map((b) => ({
                                            ...b,
                                            name: b.label || b.name || b.value,
                                            disabled: b.disabled,
                                        }))}
                                        className="location-select"
                                        placeholder={t("Select Branch")}
                                        disabled={isBranchesLoading || branches.length === 0}
                                    />
                                    {isBranchesLoading && branches.length === 0 && (
                                        <div className="dropdown-loading">
                                            <LoadingSpinner size="small" />
                                        </div>
                                    )}
                                    {!isBranchesLoading && branches.length === 0 && (
                                        <div className="no-branches-message">
                                            {t("No branches available")}
                                        </div>
                                    )}
                                </div>
                                {isV("goToCart") && (
                                    <button
                                        className={`go-to-cart-btn ${!selectedLocation ? "disabled" : ""}`}
                                        style={{
                                            opacity: !selectedLocation ? 0.6 : 1,
                                            cursor: !selectedLocation ? "not-allowed" : "pointer",
                                        }}
                                        onClick={handleGoToCart}
                                        disabled={!selectedLocation}
                                    >
                                        <FontAwesomeIcon icon={faShoppingCart} className="cart-icon" />
                                        {window.innerWidth >= 350 && <span>{t("Go to Cart")}</span>}
                                    </button>
                                )}
                            </div>
                        )}

                        <div className="filter-section">
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    alignItems: "center",
                                    gap: 12,
                                    overflowX: "auto",
                                    scrollbarWidth: "none",
                                }}
                            >
                                <Tabs
                                    tabs={filteredCategoryTabs}
                                    activeTab={activeCategory}
                                    onTabChange={handleTabChange}
                                    className=""
                                    variant="pc"
                                    catalog={true}
                                    isContentScrolled={isContentScrolled}
                                    isMobile={isMobile}
                                    loading={isLoading && !initialLoadComplete}
                                    skeletonCount={8}
                                />
                            </div>
                        </div>

                        <div className="search-section">
                            <div className="search-container">
                                {isV("search") && (
                                    <SearchInput
                                        onSearch={setSearchQuery}
                                        debounceTime={500}
                                    />
                                )}

                                <div
                                    style={{
                                        display: "flex",
                                        gap: "10px",
                                        width: "100%",
                                        ...(window.innerWidth <= 425 && window.innerWidth > 375 ? {} : {}),
                                    }}
                                >
                                    <SearchableDropdown
                                        id={`category-filter-${catalogId}`}
                                        name="categoryFilter"
                                        options={isRTL ? categoryArOptions : categoryEnOptions}
                                        className={window.innerWidth <= 375 ? "category-filter-double" : "category-filter"}
                                        placeholder={t("All Categories")}
                                        value={categoryFilter}
                                        onChange={handleCategoryFilterChange}
                                    />
                                    <SearchableDropdown
                                        id={`subcategory-filter-${catalogId}`}
                                        name="subCategoryFilter"
                                        options={isRTL ? subCategoryArOptions : subCategoryEnOptions}
                                        className={window.innerWidth <= 375 ? "category-filter-double" : "category-filter"}
                                        placeholder={!categoryFilter ? t("Select category first") : t("All Sub Categories")}
                                        value={subCategoryFilter}
                                        onChange={handleSubCategoryFilterChange}
                                        disabled={!categoryFilter}
                                    />
                                <div className="segmented">
  {activeCategory?.toLowerCase() === 'shc' &&
    items.map((item) => {
      const isActive = active?.toLowerCase() === item.key?.toLowerCase();
      return (
        <button
          key={item.key}
          type="button"
          onClick={() => handleClick(item.key)}
          aria-pressed={isActive}
          className={`segmented__btn segmented__btn--${item.key}${isActive ? " is-active" : ""} `}
        //   disabled={isSHCCoolingPeriod || false}
        >
          {item.label}
        </button>
      );
    })}
</div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="catalog-scrollable-content" ref={scrollableContentRef}>
                    <SkeletonWrapper loading={isLoading} type="card" count={8}>
                        <div className="products-grid">
                            {displayedProducts?.length > 0 ? (
                                displayedProducts.map((product) => {
                                    const isAddToCartDisabled = getIsAddToCartDisabled(product);

                                    return (
                                        <ProductCard
                                            key={product.id}
                                            product={mapProductToCardProps(product)}
                                            quantities={quantities}
                                            setQuantities={setQuantities}
                                            onQuantityChange={handleQuantityChange}
                                            onAddToCart={() => handleAddToCart(product.id)}
                                            onToggleFavorite={onToggleFavorite}
                                            onProductClick={() => handleProductClick(product)}
                                            isAdding={isAdding}
                                            isMobile={false}
                                            disabledAddToCart={isAddToCartDisabled}
                                            coolingPeriodData={coolingPeriodData}
                                        />
                                    );
                                })
                            ) : (
                                !isLoading && !isLoadingMore && !hasMore && (
                                    <div
                                        className="no-products-message"
                                        style={{
                                            textAlign: "center",
                                            position: "absolute",
                                            top: "50%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            width: "100%",
                                            color: "var(--text-secondary)",
                                            justifySelf: "anchor-center",
                                            maxWidth: "none",
                                        }}
                                    >
                                        <p>{t("No items found")}</p>
                                    </div>
                                )
                            )}
                        </div>
                    </SkeletonWrapper>

                    <SkeletonWrapper loading={isLoadingMore} type="card" count={8}></SkeletonWrapper>

                    {!hasMore && displayedProducts?.length > 0 && !isLoading && !isLoadingMore && (
                        <div className="end-of-catalog-message">
                            <p>{t("End of product catalog")}</p>
                        </div>
                    )}
                </div>

                {selectedProduct && (
                    <ProductPopup
                        product={mapProductToCardProps(selectedProduct)}
                        quantities={quantities}
                        onQuantityChange={handleQuantityChange}
                        onToggleFavorite={onToggleFavorite}
                        onAddToCart={() => handleAddToCart(selectedProduct.id)}
                        onClose={handleClosePopup}
                        isAdding={isAdding}
                        disabledAddToCart={getIsAddToCartDisabled(selectedProduct)}
                        coolingPeriodData={coolingPeriodData}
                    />
                )}
            </div>
        </div>
    );

    const renderMobileLayout = () => (
        <div>
            {activeCategory && (
                <div
                    ref={headerRef}
                    className={`catalog-fixed-header ${showHeader ? "show" : "show"}`}
                >
                    {isV("selectBranch") && (
                        <div
                            className="catalog-mobile-header"
                            style={{
                                display: "flex",
                                width: "100%",
                                alignItems: "center",
                                gap: "10px",
                                padding: "0 10px",
                            }}
                        >
                            <div className="branch-selector" style={{ flex: 1, minWidth: 0, width: "100%" }}>
                                <SearchableDropdown
                                    id={`location-select-${catalogId}`}
                                    name="locationSelect"
                                    value={selectedLocation}
                                    onChange={handleBranchSelect}
                                    options={branches.map((b) => ({
                                        ...b,
                                        name: b.label || b.name || b.value || "",
                                        disabled: b.disabled,
                                    }))}
                                    className="branch-location-select mobile"
                                    placeholder={t("Select Branch")}
                                    disabled={isBranchesLoading || branches.length === 0}
                                />
                            </div>

                            {isV("search") && (
                                <button
                                    className="search-toggle-btn"
                                    style={{
                                        flexShrink: 0,
                                        width: "40px",
                                        height: "40px",
                                        padding: "0",
                                        borderRadius: "var(--border-radius)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        background: "transparent",
                                        border: "none",
                                        cursor: "pointer",
                                        transition: "all 0.3s ease",
                                    }}
                                    onClick={() => setShowSearch(!showSearch)}
                                >
                                    <FontAwesomeIcon
                                        icon={showSearch ? faTimes : faSearch}
                                        color="black"
                                        style={{ fontSize: "22px" }}
                                        className="search-icon"
                                    />
                                </button>
                            )}

                            {isV("goToCart") && (
                                <button
                                    className={`go-to-cart-btn ${!selectedLocation ? "disabled" : ""}`}
                                    style={{
                                        flexShrink: 0,
                                        opacity: !selectedLocation ? 0.6 : 1,
                                        cursor: !selectedLocation ? "not-allowed" : "pointer",
                                        width: "40px",
                                        height: "40px",
                                        padding: "0",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    onClick={handleGoToCart}
                                    disabled={!selectedLocation}
                                >
                                    <FontAwesomeIcon icon={faShoppingCart} className="cart-icon" />
                                </button>
                            )}
                        </div>
                    )}

                    {isV("search") && (
                        <div className={`search-section ${showSearch ? "search-open" : "search-closed"}`}>
                            <div className="search-container">
                                <SearchInput
                                    onSearch={setSearchQuery}
                                    debounceTime={500}
                                />
                            </div>
                        </div>
                    )}

                    {isV("search") &&
                        (user?.userType.toLowerCase() === "employee" ||
                            user?.userType.toLowerCase() === "admin") && (
                            <div className={`search-section 'search-closed'`}>
                                <div className="search-container">
                                    <SearchInput
                                        onSearch={setSearchQuery}
                                        debounceTime={500}
                                    />
                                </div>
                            </div>
                        )}

                    <div className="filter-section">
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: 12,
                                overflowX: "auto",
                                scrollbarWidth: "none",
                            }}
                        >
                            <Tabs
                                tabs={filteredCategoryTabs}
                                activeTab={activeCategory}
                                onTabChange={handleTabChange}
                                className="catalog"
                                variant="mobile"
                                catalog={true}
                                isContentScrolled={isContentScrolled}
                                isMobile={isMobile}
                                loading={isLoading && !initialLoadComplete}
                                skeletonCount={6}
                            />
                        </div>
                    </div>

                    <div
                        className="category-and-subcategory"
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "10px",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            padding: "10px",
                        }}
                    >
                        <div className="category-dropdown-mobile" style={{ flex: 1 }}>
                            <SearchableDropdown
                                id={`category-filter-${catalogId}`}
                                name="categoryFilter"
                                options={isRTL ? categoryArOptions : categoryEnOptions}
                                className="category-filter-mobile"
                                style={{ width: "100%", borderRadius: "16px" }}
                                placeholder={t("All Categories")}
                                value={categoryFilter}
                                onChange={handleCategoryFilterChange}
                            />
                        </div>

                        <div className="subcategory-dropdown" style={{ flex: 1 }}>
                            <SearchableDropdown
                                id={`subcategory-filter-${catalogId}`}
                                name="subCategoryFilter"
                                options={isRTL ? subCategoryArOptions : subCategoryEnOptions}
                                className="subcategory-filter-mobile"
                                style={{ width: "100%", borderRadius: "16px" }}
                                placeholder={!categoryFilter ? t("Select category first") : t("All Sub Categories")}
                                value={subCategoryFilter}
                                onChange={handleSubCategoryFilterChange}
                                disabled={!categoryFilter}
                            />
                        </div>
                    </div>
                </div>
            )}

            <div
                className="catalog-scrollable-content"
                ref={scrollableContentRef}
                style={{ height: "calc(100vh - 100px)" }}
            >
                <SkeletonWrapper loading={isLoading} type="mobile_card" count={6}>
                    <div
                        className="products-grid"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                            marginTop: "10px",
                            width: "100%",
                        }}
                    >
                        {displayedProducts?.length > 0 ? (
                            displayedProducts.map((product) => {
                                const isAddToCartDisabled = getIsAddToCartDisabled(product);

                                return (
                                    <ProductCard
                                        key={product.id}
                                        product={mapProductToCardProps(product)}
                                        quantities={quantities}
                                        setQuantities={setQuantities}
                                        onQuantityChange={handleQuantityChange}
                                        onAddToCart={() => handleAddToCart(product.id)}
                                        onToggleFavorite={onToggleFavorite}
                                        onProductClick={() => handleProductClick(product)}
                                        isAdding={isAdding}
                                        isMobile={true}
                                        disabledAddToCart={isAddToCartDisabled}
                                    />
                                );
                            })
                        ) : (
                            !isLoading && !isLoadingMore && !hasMore && (
                                <div
                                    className="no-products-message"
                                    style={{
                                        textAlign: "center",
                                        position: "absolute",
                                        top: "60%",
                                        width: "100%",
                                        justifySelf: "anchor-center",
                                        maxWidth: "none",
                                    }}
                                >
                                    <p>{t("No items found")}</p>
                                </div>
                            )
                        )}
                    </div>
                </SkeletonWrapper>

                <SkeletonWrapper
                    loading={isLoadingMore}
                    type="mobile_card"
                    count={1}
                    style={{ marginTop: "10px" }}
                >
                    {" "}
                </SkeletonWrapper>

                {!hasMore && displayedProducts?.length > 0 && !isLoading && !isLoadingMore && (
                    <div className="end-of-catalog-message">
                        <p>{t("End of product catalog")}</p>
                    </div>
                )}
            </div>

            {selectedProduct && (
                <ProductPopup
                    product={mapProductToCardProps(selectedProduct)}
                    quantities={quantities}
                    onQuantityChange={handleQuantityChange}
                    onToggleFavorite={onToggleFavorite}
                    onAddToCart={() => handleAddToCart(selectedProduct.id)}
                    onClose={handleClosePopup}
                    isAdding={isAdding}
                    disabledAddToCart={getIsAddToCartDisabled(selectedProduct)}
                />
            )}
        </div>
    );

    return isMobile ? renderMobileLayout() : renderWebLayout();
};

export default CatalogLayout;